import state from "./state";
import actions from './actions'
import mutations from './mutations'

const identidySms = {
  namespaced: true,
  state,
  mutations,
  actions
}
export default identidySms;